import React from 'react';
import { Section } from '../ui/Section';
import { SectionTitle, Accent } from '../ui/SectionTitle';
import { HighlightQuote } from '../ui/HighlightQuote';
import { stuckLoop } from '../../data/content';
export function ReframeSection() {
  return <Section tone="ink" data-id="element-221" data-mp="3l77b6fo2s7d2">
      <SectionTitle className="max-w-5xl" data-id="element-222" data-mp="3g7urg3si3gep">
        No necesitas hacer más cosas. <Accent data-id="element-223" data-mp="3g9nvrcfn5ojj">Necesitas saber qué cosas realmente importan</Accent> para tu objetivo.
      </SectionTitle>

      <div className="mt-14 grid gap-12 lg:grid-cols-12 lg:gap-16" data-id="element-224" data-mp="ho4jpdnj11tk">
        <div className="space-y-5 text-lg leading-relaxed text-muted lg:col-span-5" data-id="element-225" data-mp="csfi74ry5aum">
          <p data-id="element-226" data-mp="7qzz3i9bxeev">Muchas personas no están estancadas porque no hacen nada.</p>
          <p className="text-white" data-id="element-227" data-mp="3qpp7uif23uq">
            Están estancadas porque hacen muchas cosas sin saber cómo conectarlas.
          </p>
          <p className="pt-4" data-id="element-228" data-mp="2sj1ovohdiab4">El diagnóstico te ayuda a salir de esa confusión.</p>
          <p data-id="element-229" data-mp="2ogf3a5baplmd">No para venderte una rutina cualquiera.</p>
          <p className="text-white" data-id="element-230" data-mp="2oj1b8623m354">
            Sino para entender qué está pasando y qué dirección tiene más sentido para ti.
          </p>
        </div>

        <p className="flex flex-wrap content-start gap-x-4 gap-y-1 font-display text-3xl font-black uppercase leading-none sm:text-5xl lg:col-span-7" aria-label={stuckLoop.join('. ') + '.'} data-id="element-231" data-mp="1ff86ed55uvcu">
          {stuckLoop.map((w, i) => <span key={w} aria-hidden="true" className={i === stuckLoop.length - 1 ? 'text-brand' : 'text-[#3d3d3d]'} data-id="element-232" data-mp="rr8gtgjl5azu" data-mpi={i}>
              {w}.
            </span>)}
        </p>
      </div>

      <HighlightQuote size="lg" className="mt-20" data-id="element-233" data-mp="hudjh0z1tgn5">
        Claridad primero. <span className="text-brand" data-id="element-234" data-mp="mr3yrm31487i">Transformación después.</span>
      </HighlightQuote>
    </Section>;
}